import FormContent from '@components/Forms/FormContent'
import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'

/**
 * Single row of a FieldsRepeater - renders a FormContent for one item's data plus a button
 * to remove it from the parent list.
 *
 * @component
 * @param {Object} props
 * @param {Number} props.index - Position of this item within the parent's data array.
 * @param {Object} props.model - Field-definition map passed through to FormContent.
 * @param {Function} props.setData - Called with `(itemData, index)` when this item's data changes.
 * @param {Function} [props.removeAction] - Called with `(index)` when the remove button is clicked.
 * @param {Object} [props.data={}] - Current data for this item.
 * @param {Object} [props.errors={}] - Validation errors for this item, keyed by field.
 * @returns {React.JSX.Element}
 */
const FieldsRepeaterItem = ({ index, model, setData, removeAction, data = {}, errors = {} }) => {
  const [itemErrors, setItemErrors] = useState(errors)

  /**
   * Invokes `removeAction` (if provided) with this item's index to remove it from the parent list.
   *
   * @returns {void}
   */
  const remove = () => {
    removeAction && removeAction(index)
  }

  useEffect(() => {
    setItemErrors(errors)
  }, [errors]) // Sync local item errors with parent component errors

  return (
    <div className="fields-repeater-item">
      <div className="fields-repeater-item--fields">
        <FormContent
          model={model}
          data={data}
          setData={currentData => setData(currentData, index)}
          errors={itemErrors}
          repeatable={true}
        />
      </div>
      <div className="fields-repeater-item--actions">
        <Button
          type="button"
          link
          severity="success"
          icon="fa-regular fa-trash-can"
          onClick={remove}
        />
      </div>
    </div>
  )
}

export default FieldsRepeaterItem
